import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useUserPathProjects } = getCRUDHooks({
  entityName: 'userPathProjects',
  get: ({ userId, pathId }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).paths.id(pathId).projects.get(),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useUserPathProjects,
};
